export default "__VITE_ASSET__DLwpTh3l__"